var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechnicalLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_314_32",
    "data-name": "Component 314 \\u2013 32",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41111",
    "data-name": "Group 41111",
    transform: "translate(-56 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41116",
    "data-name": "Group 41116",
    transform: "translate(9717.787 8119.787)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7983",
    "data-name": "Rectangle 7983",
    width: 148,
    height: 148,
    transform: "translate(-9661.787 -8119.788)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41624",
    "data-name": "Path 41624",
    d: "M453.611,277a3.711,3.711,0,1,1-3.711,3.711A3.675,3.675,0,0,1,453.611,277",
    transform: "translate(-10005.182 -8359.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41625",
    "data-name": "Path 41625",
    d: "M406.4,321.4a4.6,4.6,0,1,1-4.6,4.6,4.531,4.531,0,0,1,4.6-4.6",
    transform: "translate(-10028.474 -8338.393)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41626",
    "data-name": "Path 41626",
    d: "M471.5,309.966v2.375l-9.055,1.336a23.616,23.616,0,0,1-1.334,4.9l7.124,5.789-2.375,4.156-8.61-3.414a20.221,20.221,0,0,1-3.561,3.562l3.414,8.609-4.156,2.375-5.789-7.124a30.089,30.089,0,0,1-4.9,1.336l-1.337,9.054h-4.748l-1.336-9.054a23.616,23.616,0,0,1-4.9-1.336l-5.789,7.124-4.009-2.375,3.415-8.609A20.23,20.23,0,0,1,420,325.1l-8.609,3.414-2.376-4.156,7.126-5.789a30.054,30.054,0,0,1-1.336-4.9L405.9,312.34v-4.75l9.052-1.336c.3-1.336.6-2.82,1.04-4.156h11.28a14.061,14.061,0,0,0-2.375,7.867,13.8,13.8,0,1,0,27.607,0,14.43,14.43,0,0,0-2.375-7.867h11.28a33.739,33.739,0,0,1,1.037,4.156l9.055,1.336Z",
    transform: "translate(-10026.488 -8347.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41628",
    "data-name": "Path 41628",
    d: "M479.772,307.111H466.414a26.98,26.98,0,0,0-51.356,0H401.7a39.832,39.832,0,0,1,78.073,0",
    transform: "translate(-10028.522 -8360.764)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41629",
    "data-name": "Path 41629",
    d: "M455.036,285.8a1.336,1.336,0,1,1-1.336,1.336,1.335,1.335,0,0,1,1.336-1.336",
    transform: "translate(-10003.342 -8355.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41630",
    "data-name": "Path 41630",
    d: "M454.336,316.4A1.336,1.336,0,1,1,453,317.735a1.336,1.336,0,0,1,1.336-1.336",
    transform: "translate(-10003.681 -8340.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41631",
    "data-name": "Path 41631",
    d: "M446.236,325.8a1.336,1.336,0,1,1-1.336,1.334,1.333,1.333,0,0,1,1.336-1.334",
    transform: "translate(-10007.603 -8336.261)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41632",
    "data-name": "Path 41632",
    d: "M444.336,273.9A1.336,1.336,0,1,1,443,275.235a1.336,1.336,0,0,1,1.336-1.336",
    transform: "translate(-10008.522 -8361.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41633",
    "data-name": "Path 41633",
    d: "M412.536,273.9a1.336,1.336,0,1,1-1.336,1.336,1.335,1.335,0,0,1,1.336-1.336",
    transform: "translate(-10023.922 -8361.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41634",
    "data-name": "Path 41634",
    d: "M412.536,325.2a1.336,1.336,0,1,1-1.336,1.336,1.335,1.335,0,0,1,1.336-1.336",
    transform: "translate(-10023.922 -8336.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41635",
    "data-name": "Path 41635",
    d: "M401.836,283.9a1.336,1.336,0,1,1-1.336,1.336,1.336,1.336,0,0,1,1.336-1.336",
    transform: "translate(-10029.104 -8356.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41636",
    "data-name": "Path 41636",
    d: "M401.836,309.5a1.337,1.337,0,1,1-1.336,1.336,1.336,1.336,0,0,1,1.336-1.336",
    transform: "translate(-10029.104 -8344.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41637",
    "data-name": "Path 41637",
    d: "M432.842,325a14.871,14.871,0,0,1-12.321-23.156.969.969,0,0,1,1.636,1.04,12.731,12.731,0,0,0-2.226,7.273,12.911,12.911,0,0,0,25.823,0,12.4,12.4,0,0,0-2.226-7.273.969.969,0,0,1,1.636-1.04,15.2,15.2,0,0,1,2.522,8.313A14.791,14.791,0,0,1,432.842,325",
    transform: "translate(-10020.629 -8348.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41638",
    "data-name": "Path 41638",
    d: "M441.367,344.011h-4.75a.831.831,0,0,1-.891-.742l-1.336-8.46a37.45,37.45,0,0,1-3.859-1.039l-5.343,6.679c-.148.444-.594.444-1.04.3l-4.006-2.375a1,1,0,0,1-.447-1.189l3.118-7.865a25.419,25.419,0,0,1-2.82-2.82l-7.867,3.117a1,1,0,0,1-1.187-.445l-2.376-4.156a.8.8,0,0,1,.3-1.189l6.679-5.342a29.514,29.514,0,0,1-1.04-3.859l-8.459-1.189a.829.829,0,0,1-.742-.889v-4.75a.83.83,0,0,1,.742-.891l8.459-1.336q.448-1.781.892-3.562a.939.939,0,1,1,1.781.594c-.447,1.336-.742,2.67-1.039,3.859a.8.8,0,0,1-.742.742l-8.313,1.187v3.117l8.313,1.186a.8.8,0,0,1,.742.742,25.045,25.045,0,0,0,1.334,4.751.918.918,0,0,1-.3,1.039l-6.531,5.195,1.631,2.672,7.868-3.117a.913.913,0,0,1,1.037.3,24.739,24.739,0,0,0,3.415,3.414.983.983,0,0,1,.3,1.039l-3.115,7.867,2.672,1.484,5.195-6.531a.985.985,0,0,1,1.039-.3,24.815,24.815,0,0,0,4.75,1.337.8.8,0,0,1,.742.742l1.187,8.31h3.115l1.189-8.31a.8.8,0,0,1,.742-.742,24.83,24.83,0,0,0,4.748-1.337.921.921,0,0,1,1.04.3l5.195,6.531,2.67-1.484-3.115-7.867a.917.917,0,0,1,.3-1.039,18.614,18.614,0,0,0,3.414-3.414.981.981,0,0,1,1.039-.3l7.866,3.117,1.484-2.672-6.532-5.195a.986.986,0,0,1-.3-1.039,25.048,25.048,0,0,0,1.336-4.751.8.8,0,0,1,.742-.742l8.312-1.186v-3.117L462.3,307.2a.8.8,0,0,1-.742-.742,16.338,16.338,0,0,0-1.04-3.859.939.939,0,0,1,1.783-.594,15.735,15.735,0,0,1,.891,3.562l8.459,1.336a.83.83,0,0,1,.742.891v4.9a.831.831,0,0,1-.742.892l-8.459,1.187a37.043,37.043,0,0,1-1.039,3.858l6.679,5.345a1.154,1.154,0,0,1,.3,1.187l-2.375,4.156a.994.994,0,0,1-1.187.444l-7.866-3.115a25.426,25.426,0,0,1-2.82,2.82l3.117,7.867a.993.993,0,0,1-.447,1.187l-3.711,2.226a.8.8,0,0,1-1.186-.3l-5.343-6.679a29.484,29.484,0,0,1-3.861,1.039l-1.186,8.46a.831.831,0,0,1-.891.742",
    transform: "translate(-10026.779 -8348.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41639",
    "data-name": "Path 41639",
    d: "M407.909,300.376a.544.544,0,0,1-.445-.148.935.935,0,0,1-.447-1.187,33.12,33.12,0,0,1,12.469-14.249,34.445,34.445,0,0,1,18.7-5.492,34.829,34.829,0,0,1,18.7,5.492,36.125,36.125,0,0,1,12.466,14.249.9.9,0,1,1-1.631.742,32.558,32.558,0,0,0-58.925,0,1.221,1.221,0,0,1-.891.594",
    transform: "translate(-10025.975 -8358.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41640",
    "data-name": "Path 41640",
    d: "M479.668,304.082H466.607a1,1,0,0,1-.891-.594,26.085,26.085,0,0,0-49.574,0,.815.815,0,0,1-.891.594H402.191a.891.891,0,1,1,0-1.781h12.468a27.976,27.976,0,0,1,9.8-13.21,27.584,27.584,0,0,1,16.624-5.492,28.105,28.105,0,0,1,26.42,18.7h12.468a.958.958,0,0,1,.891.891c-.3.445-.6.891-1.187.891",
    transform: "translate(-10028.716 -8356.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41641",
    "data-name": "Path 41641",
    d: "M481.244,315.268H401.391a.947.947,0,0,1-.892-.867,35.3,35.3,0,0,1,.892-7.96,40.509,40.509,0,0,1,13.95-22.724,41.91,41.91,0,0,1,25.974-9.116,41.046,41.046,0,0,1,25.974,9.116,39.726,39.726,0,0,1,13.953,22.724,36.333,36.333,0,0,1,.889,7.96.742.742,0,0,1-.3.577,1.136,1.136,0,0,1-.594.289m-78.814-1.737h77.923a35.338,35.338,0,0,0-.742-6.8c-3.711-17.511-19.742-30.393-38.145-30.393s-34.435,12.738-38.145,30.393a25.875,25.875,0,0,0-.891,6.8",
    transform: "translate(-10029.104 -8361.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41642",
    "data-name": "Path 41642",
    d: "M406.74,331.981a5.641,5.641,0,1,1,5.64-5.642,5.735,5.735,0,0,1-5.64,5.642m0-9.352a3.711,3.711,0,1,0,3.711,3.711,3.676,3.676,0,0,0-3.711-3.711",
    transform: "translate(-10028.813 -8338.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41643",
    "data-name": "Path 41643",
    d: "M453.9,285.6a4.6,4.6,0,1,1,4.6-4.6,4.624,4.624,0,0,1-4.6,4.6m0-7.421a2.818,2.818,0,0,0-2.82,2.82,2.82,2.82,0,0,0,5.64,0,2.818,2.818,0,0,0-2.82-2.82",
    transform: "translate(-10005.472 -8360.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41117",
    "data-name": "Group 41117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41644",
    "data-name": "Path 41644",
    d: "M453.611,277a3.711,3.711,0,1,1-3.711,3.711A3.675,3.675,0,0,1,453.611,277",
    transform: "translate(-10005.182 -8359.893)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41645",
    "data-name": "Path 41645",
    d: "M406.4,321.4a4.6,4.6,0,1,1-4.6,4.6,4.531,4.531,0,0,1,4.6-4.6",
    transform: "translate(-10028.474 -8338.393)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41646",
    "data-name": "Path 41646",
    d: "M471.5,309.966v2.375l-9.055,1.336a23.616,23.616,0,0,1-1.334,4.9l7.124,5.789-2.375,4.156-8.61-3.414a20.221,20.221,0,0,1-3.561,3.562l3.414,8.609-4.156,2.375-5.789-7.124a30.089,30.089,0,0,1-4.9,1.336l-1.337,9.054h-4.748l-1.336-9.054a23.616,23.616,0,0,1-4.9-1.336l-5.789,7.124-4.009-2.375,3.415-8.609A20.23,20.23,0,0,1,420,325.1l-8.609,3.414-2.376-4.156,7.126-5.789a30.054,30.054,0,0,1-1.336-4.9L405.9,312.34v-4.75l9.052-1.336c.3-1.336.6-2.82,1.04-4.156h11.28a14.061,14.061,0,0,0-2.375,7.867,13.8,13.8,0,1,0,27.607,0,14.43,14.43,0,0,0-2.375-7.867h11.28a33.739,33.739,0,0,1,1.037,4.156l9.055,1.336Z",
    transform: "translate(-10026.488 -8347.738)",
    fill: "#4eb2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41648",
    "data-name": "Path 41648",
    d: "M479.772,307.111H466.414a26.98,26.98,0,0,0-51.356,0H401.7a39.832,39.832,0,0,1,78.073,0",
    transform: "translate(-10028.522 -8360.764)",
    fill: "#4eb2a2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_41649",
    "data-name": "Path 41649",
    d: "M455.036,285.8a1.336,1.336,0,1,1-1.336,1.336,1.335,1.335,0,0,1,1.336-1.336",
    transform: "translate(-10003.342 -8355.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41650",
    "data-name": "Path 41650",
    d: "M454.336,316.4A1.336,1.336,0,1,1,453,317.735a1.336,1.336,0,0,1,1.336-1.336",
    transform: "translate(-10003.681 -8340.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41651",
    "data-name": "Path 41651",
    d: "M446.236,325.8a1.336,1.336,0,1,1-1.336,1.334,1.333,1.333,0,0,1,1.336-1.334",
    transform: "translate(-10007.603 -8336.261)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41652",
    "data-name": "Path 41652",
    d: "M444.336,273.9A1.336,1.336,0,1,1,443,275.235a1.336,1.336,0,0,1,1.336-1.336",
    transform: "translate(-10008.522 -8361.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41653",
    "data-name": "Path 41653",
    d: "M412.536,273.9a1.336,1.336,0,1,1-1.336,1.336,1.335,1.335,0,0,1,1.336-1.336",
    transform: "translate(-10023.922 -8361.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41654",
    "data-name": "Path 41654",
    d: "M412.536,325.2a1.336,1.336,0,1,1-1.336,1.336,1.335,1.335,0,0,1,1.336-1.336",
    transform: "translate(-10023.922 -8336.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41655",
    "data-name": "Path 41655",
    d: "M401.836,283.9a1.336,1.336,0,1,1-1.336,1.336,1.336,1.336,0,0,1,1.336-1.336",
    transform: "translate(-10029.104 -8356.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41656",
    "data-name": "Path 41656",
    d: "M401.836,309.5a1.337,1.337,0,1,1-1.336,1.336,1.336,1.336,0,0,1,1.336-1.336",
    transform: "translate(-10029.104 -8344.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41657",
    "data-name": "Path 41657",
    d: "M432.842,325a14.871,14.871,0,0,1-12.321-23.156.969.969,0,0,1,1.636,1.04,12.731,12.731,0,0,0-2.226,7.273,12.911,12.911,0,0,0,25.823,0,12.4,12.4,0,0,0-2.226-7.273.969.969,0,0,1,1.636-1.04,15.2,15.2,0,0,1,2.522,8.313A14.791,14.791,0,0,1,432.842,325",
    transform: "translate(-10020.629 -8348.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41658",
    "data-name": "Path 41658",
    d: "M441.367,344.011h-4.75a.831.831,0,0,1-.891-.742l-1.336-8.46a37.45,37.45,0,0,1-3.859-1.039l-5.343,6.679c-.148.444-.594.444-1.04.3l-4.006-2.375a1,1,0,0,1-.447-1.189l3.118-7.865a25.419,25.419,0,0,1-2.82-2.82l-7.867,3.117a1,1,0,0,1-1.187-.445l-2.376-4.156a.8.8,0,0,1,.3-1.189l6.679-5.342a29.514,29.514,0,0,1-1.04-3.859l-8.459-1.189a.829.829,0,0,1-.742-.889v-4.75a.83.83,0,0,1,.742-.891l8.459-1.336q.448-1.781.892-3.562a.939.939,0,1,1,1.781.594c-.447,1.336-.742,2.67-1.039,3.859a.8.8,0,0,1-.742.742l-8.313,1.187v3.117l8.313,1.186a.8.8,0,0,1,.742.742,25.045,25.045,0,0,0,1.334,4.751.918.918,0,0,1-.3,1.039l-6.531,5.195,1.631,2.672,7.868-3.117a.913.913,0,0,1,1.037.3,24.739,24.739,0,0,0,3.415,3.414.983.983,0,0,1,.3,1.039l-3.115,7.867,2.672,1.484,5.195-6.531a.985.985,0,0,1,1.039-.3,24.815,24.815,0,0,0,4.75,1.337.8.8,0,0,1,.742.742l1.187,8.31h3.115l1.189-8.31a.8.8,0,0,1,.742-.742,24.83,24.83,0,0,0,4.748-1.337.921.921,0,0,1,1.04.3l5.195,6.531,2.67-1.484-3.115-7.867a.917.917,0,0,1,.3-1.039,18.614,18.614,0,0,0,3.414-3.414.981.981,0,0,1,1.039-.3l7.866,3.117,1.484-2.672-6.532-5.195a.986.986,0,0,1-.3-1.039,25.048,25.048,0,0,0,1.336-4.751.8.8,0,0,1,.742-.742l8.312-1.186v-3.117L462.3,307.2a.8.8,0,0,1-.742-.742,16.338,16.338,0,0,0-1.04-3.859.939.939,0,0,1,1.783-.594,15.735,15.735,0,0,1,.891,3.562l8.459,1.336a.83.83,0,0,1,.742.891v4.9a.831.831,0,0,1-.742.892l-8.459,1.187a37.043,37.043,0,0,1-1.039,3.858l6.679,5.345a1.154,1.154,0,0,1,.3,1.187l-2.375,4.156a.994.994,0,0,1-1.187.444l-7.866-3.115a25.426,25.426,0,0,1-2.82,2.82l3.117,7.867a.993.993,0,0,1-.447,1.187l-3.711,2.226a.8.8,0,0,1-1.186-.3l-5.343-6.679a29.484,29.484,0,0,1-3.861,1.039l-1.186,8.46a.831.831,0,0,1-.891.742",
    transform: "translate(-10026.779 -8348.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41659",
    "data-name": "Path 41659",
    d: "M407.909,300.376a.544.544,0,0,1-.445-.148.935.935,0,0,1-.447-1.187,33.12,33.12,0,0,1,12.469-14.249,34.445,34.445,0,0,1,18.7-5.492,34.829,34.829,0,0,1,18.7,5.492,36.125,36.125,0,0,1,12.466,14.249.9.9,0,1,1-1.631.742,32.558,32.558,0,0,0-58.925,0,1.221,1.221,0,0,1-.891.594",
    transform: "translate(-10025.975 -8358.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41660",
    "data-name": "Path 41660",
    d: "M479.668,304.082H466.607a1,1,0,0,1-.891-.594,26.085,26.085,0,0,0-49.574,0,.815.815,0,0,1-.891.594H402.191a.891.891,0,1,1,0-1.781h12.468a27.976,27.976,0,0,1,9.8-13.21,27.584,27.584,0,0,1,16.624-5.492,28.105,28.105,0,0,1,26.42,18.7h12.468a.958.958,0,0,1,.891.891c-.3.445-.6.891-1.187.891",
    transform: "translate(-10028.716 -8356.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41661",
    "data-name": "Path 41661",
    d: "M481.244,315.267H401.391a.947.947,0,0,1-.892-.867,35.3,35.3,0,0,1,.892-7.96,40.508,40.508,0,0,1,13.95-22.724,41.91,41.91,0,0,1,25.974-9.116,41.046,41.046,0,0,1,25.974,9.116,39.726,39.726,0,0,1,13.953,22.724,36.332,36.332,0,0,1,.889,7.96.742.742,0,0,1-.3.577,1.136,1.136,0,0,1-.594.289M402.43,313.53h77.923a35.337,35.337,0,0,0-.742-6.8c-3.711-17.511-19.742-30.393-38.145-30.393s-34.435,12.737-38.145,30.393a25.874,25.874,0,0,0-.891,6.8",
    transform: "translate(-10029.104 -8361.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41662",
    "data-name": "Path 41662",
    d: "M406.74,331.981a5.641,5.641,0,1,1,5.64-5.642,5.735,5.735,0,0,1-5.64,5.642m0-9.352a3.711,3.711,0,1,0,3.711,3.711,3.676,3.676,0,0,0-3.711-3.711",
    transform: "translate(-10028.813 -8338.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41663",
    "data-name": "Path 41663",
    d: "M453.9,285.6a4.6,4.6,0,1,1,4.6-4.6,4.624,4.624,0,0,1-4.6,4.6m0-7.421a2.818,2.818,0,0,0-2.82,2.82,2.82,2.82,0,0,0,5.64,0,2.818,2.818,0,0,0-2.82-2.82",
    transform: "translate(-10005.472 -8360.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42528",
    "data-name": "Path 42528",
    d: "M327.38,103.851a1.088,1.088,0,0,1-.912-.5l-3.488-4.34A1.088,1.088,0,0,1,324.8,97.83l2.818,3.309,9.3-8.247a1.088,1.088,0,1,1,1.4,1.666L328.079,103.6A1.088,1.088,0,0,1,327.38,103.851Z",
    transform: "translate(-9917.573 -8156.546)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicalLight);
export default __webpack_public_path__ + "static/media/technical_light.2037f29723ab9e41cad88d84ee6aa5d7.svg";
export { ForwardRef as ReactComponent };